import { AuthService } from 'src/app/services';
import { FiltersOperator } from './../api/filters-operator.api';
import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, inject } from '@angular/core';
import { UserRoleEnum } from 'src/app/enums/userRoleEnum';
import { ActivatedRoute, Data } from '@angular/router';
import { UtilsService } from 'src/app/services/utils.service';
import { ExportFilter, FilterMappingService } from 'src/app/models/filter-objects';
import { DxLoadPanelComponent } from 'devextreme-angular';
import { InitializedEvent } from 'devextreme/ui/load_panel';
import { CounterGroups, LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { GroupData } from 'src/app/tools/groups-counter';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-filters-group',
    templateUrl: './filters-group.component.html',
    styleUrls: ['./filters-group.component.scss'],
    standalone: false
})
export class FiltersGroupComponent implements OnInit, AfterViewInit {

	@Input({required: true})
	public instanceIdentifier!: number;

	protected contentId: string;

	@Input() public filtersOperator: FiltersOperator;
	@Input() public showApplyButton: boolean = true;
	@Input() public showResetButton: boolean = true;
	@Input() public showPageOptionsPopUpButton: boolean = true;

	public isAdmin: boolean = false;

	/**
	 * The private identifier for the filters group, computed from the `routeId` and `id`.
	 */
	private _instanceRouteHash: number;
	public get instanceRouteHash(): number {
		return this._instanceRouteHash;
	}

	/**
	 * The private numeric identifier of the page.
	 */
	private _routeId: number;

	@ViewChild(DxLoadPanelComponent, { static: true })
	public loadPanel: DxLoadPanelComponent;

	public onLoadPanelInitialized(evt: InitializedEvent, dxLoadPanelComponent: DxLoadPanelComponent): void {
		this.loadPanel = dxLoadPanelComponent;
	}

	public repaintLoadPanel(): void {
		if (this.loadPanel) {
			this.loadPanel.instance.repaint();
		}
	}

	private _authService: AuthService = inject(AuthService);
	private _activatedRoute: ActivatedRoute = inject(ActivatedRoute);

	private _loadingIndicationService: LoadingIndicationService = inject(LoadingIndicationService);

	@Input()
	public loadingHeight: string = "auto";

	protected loading: boolean = false;

	constructor() {}

	async ngOnInit() {
		this.isAdmin = this._authService.currentRole === UserRoleEnum.Admin;

		const routeData: Data = await firstValueFrom(this._activatedRoute.data);

		// Assuming the route data contains the `routeId`.
		this._routeId = routeData.id;

		this._instanceRouteHash = UtilsService.computeRouteHash(this._routeId, this.instanceIdentifier);

		this.contentId = `#filters-grid-content-${this._instanceRouteHash}`;

		this.filtersOperator.initialize(
			this._instanceRouteHash,
			this._routeId,
			this.instanceIdentifier
		);

		this._loadingIndicationService.isLoadingGroupsCounter.getOnIncreaseSubject(CounterGroups.FILTERS_LOAD).pipe(
			takeUntil(this._destroying$)
		).subscribe(
			(value: Map<string, GroupData>) => {
				const groupData: GroupData = value.get(this._instanceRouteHash.toString());

				if (groupData && groupData.quantity) {
					this.loading = true;
				}
			}
		);

		this._loadingIndicationService.isLoadingGroupsCounter.getOnDecreaseSubject(CounterGroups.FILTERS_LOAD).pipe(
			takeUntil(this._destroying$)
		).subscribe(
			(value: Map<string, GroupData>) => {
				const groupData: GroupData = value.get(this._instanceRouteHash.toString());

				if (groupData && groupData.quantity === 0 && this.loading) {
					this.loading = false;
				}
			}
		);
	}

	ngAfterViewInit(): void {
		this.repaintLoadPanel();
	}

	/**
	 * Emits a value when the component is about to be destroyed.
	 * Used to automatically unsubscribe from observables to prevent memory leaks.
	 *
	 * - `takeUntil(this._destroying$)` should be used in subscriptions.
	 * - `next()` is called in `ngOnDestroy` to signal unsubscription.
	 * - `complete()` ensures the `Subject` is fully closed, freeing resources.
	 */
	private readonly _destroying$ = new Subject<void>();

	ngOnDestroy() {
		this._destroying$.next(); // Signal all observers to complete.
		this._destroying$.complete(); // Fully close the Subject to avoid memory leaks.
	}

	ExportToExcelFilters: ExportFilter[] = [];
	@Output() ExportToExcelFiltersEmitted = new EventEmitter<ExportFilter[]>();
	filterMappingService = new FilterMappingService()
	filterChangesTrack() {
		if(this.ExportToExcelFiltersEmitted) {
		this.ExportToExcelFilters = this.filterMappingService.mapQueryFilterOutputToFilterValue(this.filtersOperator.overviewFiltersOutput.filters);
		this.ExportToExcelFiltersEmitted.emit(this.ExportToExcelFilters);
		}
	}
}
